import { render, staticRenderFns } from "./Wework.vue?vue&type=template&id=db43f750&scoped=true"
import script from "./Wework.vue?vue&type=script&lang=js"
export * from "./Wework.vue?vue&type=script&lang=js"
import style0 from "./Wework.vue?vue&type=style&index=0&id=db43f750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db43f750",
  null
  
)

export default component.exports